import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetUsageFeeRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getUsageFee = async (
  instance: AxiosInstance,
  params: DefaultApiGetUsageFeeRequest
) => {
  return await userApiDefaultApiFactory(instance).getUsageFee(params)
}

// Do Not Remove this line ===@import api client===
